<div sm-restrict-width>
  <mat-card sm-center smc-stripe-card-on-file-container>
  <mat-card-title *ngIf="!clientHasStripeAccount">
    {{ requirementText }}
  </mat-card-title>
  <p sm-center *ngIf="!this.userService.isLoggedIn()">
    {{ 'STRIPE.NO_SHOW_CHARGE' | translate:{ percentage: noShowPercentage } }}
  </p>
  <mat-card-content *ngIf="this.userService.isLoggedIn()">
    <!-- Already has a card on file -->
    <div
      *ngIf="
        clientHasStripeAccount &&
        !changeCard &&
        cardInfo !== undefined &&
        !cardExpired
      "
    >
      <p sm-center>
        {{ 'STRIPE.NO_SHOW_CHARGE_CARD' | translate:{ brand: cardInfo.brand, last4: cardInfo.last4, percentage: noShowPercentage } }}
      </p>

      <a class="change-card" (click)="changeCardOnFile()" target="_blank"
        >{{ 'STRIPE.CHANGE_CARD' | translate }}</a
      >
    </div>
    <!--  Card expired -->
    <div
      *ngIf="
        clientHasStripeAccount &&
        !changeCard &&
        cardInfo !== undefined &&
        cardExpired
      "
    >
      <p sm-center class="warning">
        {{ 'STRIPE.CARD_EXPIRED' | translate:{ brand: cardInfo.brand, last4: cardInfo.last4 } }}
      </p>
      <p sm-center>
        {{ 'STRIPE.NO_SHOW_CHARGE' | translate:{ percentage: noShowPercentage } }}
      </p>

      <a class="change-card" (click)="changeCardOnFile()" target="_blank"
        >{{ 'STRIPE.CHANGE_CARD' | translate }}</a
      >
    </div>
    <!-- No card on file, add one -->
    <div *ngIf="!clientHasStripeAccount || cardInfo === undefined">
      <p sm-center>
        {{ 'STRIPE.NO_SHOW_CHARGE' | translate:{ percentage: noShowPercentage } }}
      </p>
      <p sm-center style="font-weight: bold">{{ 'STRIPE.ENTER_CARD_DETAILS' | translate }}</p>
      <div
        class="card-element"
        [ngStyle]="{ display: stripeReady ? 'block' : 'none' }"
      >
        <div #paymentElement class="card-element-inner"></div>
      </div>

      <div class="stripe-charge-buttons">
        <p
          *ngIf="errorMessage || cardErrors"
          class="smc-stripe-error text-align-center"
        >
          {{ errorMessage }}{{ cardErrors }}
        </p>
      </div>

      <mat-checkbox [(ngModel)]="saveCardChecked"
        >{{ 'STRIPE.AUTHORIZE_STORE_CARD' | translate }}</mat-checkbox
      >
      <p
        sm-center
        class="gray-text margin-top-10 width-50 margin-left-right-auto"
      >
        {{ 'STRIPE.AUTHORIZE_SALON_CHARGE' | translate:{ salonName: this.userService.getSalon().getName() } }}
      </p>
    </div>
    <!-- Change card on file -->
    <div *ngIf="changeCard">
      <p sm-center style="font-weight: bold">{{ 'STRIPE.ENTER_CARD_DETAILS' | translate }}</p>
      <div
        class="card-element"
        [ngStyle]="{ display: stripeReady ? 'block' : 'none' }"
      >
        <div #paymentElementChangeCard class="card-element-inner"></div>
      </div>

      <div class="stripe-charge-buttons">
        <p
          *ngIf="errorMessage || cardErrors"
          class="smc-stripe-error text-align-center"
        >
          {{ errorMessage }}{{ cardErrors }}
        </p>
      </div>
    </div>
  </mat-card-content>
  <div sm-center class="margin-top-20">
    <!-- User does not have a card on file yet -->
    <button
      class="smc-button-large smc-button-primary margin-top-20"
      mat-raised-button
      *ngIf="
        this.userService.isLoggedIn() &&
        (!this.clientHasStripeAccount || cardInfo === undefined)
      "
      [disabled]="!cardInputComplete || !saveCardChecked || savingStripe"
      (click)="saveCardToPayOnNoShow()"
    >
      {{ buttonText }}
      <mat-progress-spinner
        *ngIf="savingStripe"
        [diameter]="20"
        mode="indeterminate"
      ></mat-progress-spinner>
    </button>
    <!-- User is changing card on file -->
    <button
      class="smc-button-large smc-button-primary margin-top-20"
      mat-raised-button
      *ngIf="this.userService.isLoggedIn() && changeCard"
      [disabled]="!cardInputComplete || savingStripe"
      (click)="saveCardToPayOnNoShow()"
    >
      {{ buttonText }}
      <mat-progress-spinner
        *ngIf="savingStripe"
        [diameter]="20"
        mode="indeterminate"
      ></mat-progress-spinner>
    </button>
    <!-- User already has a card on file -->
    <button
      class="smc-button-large smc-button-primary margin-top-20"
      mat-raised-button
      *ngIf="
        this.userService.isLoggedIn() &&
        this.clientHasStripeAccount &&
        !changeCard &&
        cardInfo !== undefined
      "
      [disabled]="savingStripe || cardExpired"
      (click)="setupConfirmationSavedCard()"
    >
      {{ buttonText }}
      <mat-progress-spinner
        *ngIf="savingStripe"
        [diameter]="20"
        mode="indeterminate"
      ></mat-progress-spinner>
    </button>
    <!--    <button-->
    <!--      (click)="chargeAfterSave()"-->
    <!--    >-->
    <!--      charge after save-->
    <!--    </button>-->
    <!-- <p
      *ngIf="this.userService.isLoggedIn()"
      sm-center
      class="gray-text margin-top-20"
    >
      <strong>Cancellation Policy2</strong>
    </p>
    <p
      *ngIf="this.userService.isLoggedIn()"
      sm-center
      class="gray-text margin-top-10 width-50 margin-left-right-auto"
      [innerHTML]="cancellationPolicy"
    ></p> -->
  </div>
</mat-card>
<!--*ngIf="!chargeOnNoShow"-->
<!--mat-raised-button-->
</div>
